/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCustomerRequest,
  CustomerListResponse,
  CustomerResponse,
  UpdateCustomerRequest,
} from '../models/index';
import {
    CreateCustomerRequestFromJSON,
    CreateCustomerRequestToJSON,
    CustomerListResponseFromJSON,
    CustomerListResponseToJSON,
    CustomerResponseFromJSON,
    CustomerResponseToJSON,
    UpdateCustomerRequestFromJSON,
    UpdateCustomerRequestToJSON,
} from '../models/index';

export interface CreateCustomerOperationRequest {
    createCustomerRequest: CreateCustomerRequest;
}

export interface DecommissionCustomerTenantsRequest {
    id: string;
}

export interface DeleteCustomerRequest {
    id: string;
}

export interface GetCustomerRequest {
    id: string;
}

export interface GetCustomersRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    companyName?: string;
    industryType?: string;
    companySize?: string;
    country?: string;
    includeCustomersWithoutTenants?: boolean;
}

export interface GetCustomersByIndustryRequest {
    industry: string;
    page?: string;
    pageSize?: string;
}

export interface GetCustomersBySizeRequest {
    size: string;
    page?: string;
    pageSize?: string;
}

export interface SearchCustomersRequest {
    query?: string;
    industry?: string;
    size?: string;
    status?: string;
    page?: string;
    pageSize?: string;
}

export interface UpdateCustomerOperationRequest {
    id: string;
    updateCustomerRequest: UpdateCustomerRequest;
}

/**
 * CustomersApi - interface
 * 
 * @export
 * @interface CustomersApiInterface
 */
export interface CustomersApiInterface {
    /**
     * Creates a new customer (admin only)
     * @summary Create customer
     * @param {CreateCustomerRequest} createCustomerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    createCustomerRaw(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>>;

    /**
     * Creates a new customer (admin only)
     * Create customer
     */
    createCustomer(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse>;

    /**
     * Suspends all tenants for a customer and schedules purge per retention policy
     * @summary Decommission all customer\'s tenants
     * @param {string} id Customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    decommissionCustomerTenantsRaw(requestParameters: DecommissionCustomerTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Suspends all tenants for a customer and schedules purge per retention policy
     * Decommission all customer\'s tenants
     */
    decommissionCustomerTenants(requestParameters: DecommissionCustomerTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Deletes a customer (admin only)
     * @summary Delete customer
     * @param {string} id Customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    deleteCustomerRaw(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a customer (admin only)
     * Delete customer
     */
    deleteCustomer(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a specific customer by ID (admin only)
     * @summary Get customer by ID
     * @param {string} id Customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>>;

    /**
     * Retrieves a specific customer by ID (admin only)
     * Get customer by ID
     */
    getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse>;

    /**
     * Retrieves paginated list of customers (admin only)
     * @summary Get all customers
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [companyName] 
     * @param {string} [industryType] 
     * @param {string} [companySize] 
     * @param {string} [country] 
     * @param {boolean} [includeCustomersWithoutTenants] Include customers without tenants (for tenant creation)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    getCustomersRaw(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>>;

    /**
     * Retrieves paginated list of customers (admin only)
     * Get all customers
     */
    getCustomers(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse>;

    /**
     * Retrieves customers filtered by industry (admin only)
     * @summary Get customers by industry
     * @param {string} industry Industry name
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    getCustomersByIndustryRaw(requestParameters: GetCustomersByIndustryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>>;

    /**
     * Retrieves customers filtered by industry (admin only)
     * Get customers by industry
     */
    getCustomersByIndustry(requestParameters: GetCustomersByIndustryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse>;

    /**
     * Retrieves customers filtered by company size (admin only)
     * @summary Get customers by size
     * @param {string} size Company size
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    getCustomersBySizeRaw(requestParameters: GetCustomersBySizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>>;

    /**
     * Retrieves customers filtered by company size (admin only)
     * Get customers by size
     */
    getCustomersBySize(requestParameters: GetCustomersBySizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse>;

    /**
     * Searches customers by various criteria (admin only)
     * @summary Search customers
     * @param {string} [query] Search query
     * @param {string} [industry] Industry filter
     * @param {string} [size] Size filter
     * @param {string} [status] Status filter
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    searchCustomersRaw(requestParameters: SearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>>;

    /**
     * Searches customers by various criteria (admin only)
     * Search customers
     */
    searchCustomers(requestParameters: SearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse>;

    /**
     * Updates an existing customer (admin only)
     * @summary Update customer
     * @param {string} id Customer ID
     * @param {UpdateCustomerRequest} updateCustomerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    updateCustomerRaw(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>>;

    /**
     * Updates an existing customer (admin only)
     * Update customer
     */
    updateCustomer(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse>;

}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI implements CustomersApiInterface {

    /**
     * Creates a new customer (admin only)
     * Create customer
     */
    async createCustomerRaw(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>> {
        if (requestParameters['createCustomerRequest'] == null) {
            throw new runtime.RequiredError(
                'createCustomerRequest',
                'Required parameter "createCustomerRequest" was null or undefined when calling createCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCustomerRequestToJSON(requestParameters['createCustomerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new customer (admin only)
     * Create customer
     */
    async createCustomer(requestParameters: CreateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse> {
        const response = await this.createCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Suspends all tenants for a customer and schedules purge per retention policy
     * Decommission all customer\'s tenants
     */
    async decommissionCustomerTenantsRaw(requestParameters: DecommissionCustomerTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling decommissionCustomerTenants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{id}/decommission-tenants`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Suspends all tenants for a customer and schedules purge per retention policy
     * Decommission all customer\'s tenants
     */
    async decommissionCustomerTenants(requestParameters: DecommissionCustomerTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.decommissionCustomerTenantsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a customer (admin only)
     * Delete customer
     */
    async deleteCustomerRaw(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a customer (admin only)
     * Delete customer
     */
    async deleteCustomer(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific customer by ID (admin only)
     * Get customer by ID
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific customer by ID (admin only)
     * Get customer by ID
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of customers (admin only)
     * Get all customers
     */
    async getCustomersRaw(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['companyName'] = requestParameters['companyName'];
        }

        if (requestParameters['industryType'] != null) {
            queryParameters['industryType'] = requestParameters['industryType'];
        }

        if (requestParameters['companySize'] != null) {
            queryParameters['companySize'] = requestParameters['companySize'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['includeCustomersWithoutTenants'] != null) {
            queryParameters['includeCustomersWithoutTenants'] = requestParameters['includeCustomersWithoutTenants'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of customers (admin only)
     * Get all customers
     */
    async getCustomers(requestParameters: GetCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse> {
        const response = await this.getCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves customers filtered by industry (admin only)
     * Get customers by industry
     */
    async getCustomersByIndustryRaw(requestParameters: GetCustomersByIndustryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>> {
        if (requestParameters['industry'] == null) {
            throw new runtime.RequiredError(
                'industry',
                'Required parameter "industry" was null or undefined when calling getCustomersByIndustry().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/industry/{industry}`;
        urlPath = urlPath.replace(`{${"industry"}}`, encodeURIComponent(String(requestParameters['industry'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves customers filtered by industry (admin only)
     * Get customers by industry
     */
    async getCustomersByIndustry(requestParameters: GetCustomersByIndustryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse> {
        const response = await this.getCustomersByIndustryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves customers filtered by company size (admin only)
     * Get customers by size
     */
    async getCustomersBySizeRaw(requestParameters: GetCustomersBySizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>> {
        if (requestParameters['size'] == null) {
            throw new runtime.RequiredError(
                'size',
                'Required parameter "size" was null or undefined when calling getCustomersBySize().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/size/{size}`;
        urlPath = urlPath.replace(`{${"size"}}`, encodeURIComponent(String(requestParameters['size'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves customers filtered by company size (admin only)
     * Get customers by size
     */
    async getCustomersBySize(requestParameters: GetCustomersBySizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse> {
        const response = await this.getCustomersBySizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches customers by various criteria (admin only)
     * Search customers
     */
    async searchCustomersRaw(requestParameters: SearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['industry'] != null) {
            queryParameters['industry'] = requestParameters['industry'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerListResponseFromJSON(jsonValue));
    }

    /**
     * Searches customers by various criteria (admin only)
     * Search customers
     */
    async searchCustomers(requestParameters: SearchCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerListResponse> {
        const response = await this.searchCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing customer (admin only)
     * Update customer
     */
    async updateCustomerRaw(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCustomer().'
            );
        }

        if (requestParameters['updateCustomerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCustomerRequest',
                'Required parameter "updateCustomerRequest" was null or undefined when calling updateCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCustomerRequestToJSON(requestParameters['updateCustomerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing customer (admin only)
     * Update customer
     */
    async updateCustomer(requestParameters: UpdateCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponse> {
        const response = await this.updateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
